import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { RentalPhotos, uploadRentalPhotos } from "@/components/rentals/RentalPhotos";
import { api, errMsg } from "@/lib/api";
import { todayISO, fmtDate } from "@/lib/format";

export const ReturnDialog = ({ rental, onClose, onSaved }) => {
  const [f, setF] = useState({ return_date: todayISO(), km_end: "", return_notes: "" });
  const [photos, setPhotos] = useState([]);
  const [files, setFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (rental) { setF({ return_date: rental.return_date || todayISO(), km_end: rental.km_end ?? "", return_notes: rental.return_notes || "" }); setPhotos(rental.photos?.return || []); setFiles([]); }
  }, [rental]);
  if (!rental) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const first = rental.status === "ATTIVO";
  const km = f.km_end !== "" ? Number(f.km_end) - rental.km_start : null;

  const save = async () => {
    if (first && !window.confirm(`Confermi la riconsegna di ${rental.plate}? Il mezzo verrà disattivato e spostato nello storico.`)) return;
    setSaving(true);
    try {
      await api.put(`/rentals/${rental.id}/return`, { ...f, km_end: Number(f.km_end || 0) });
      await uploadRentalPhotos(rental.id, "return", files);
      toast.success(first ? "Riconsegna registrata: mezzo spostato nello storico" : "Riconsegna aggiornata");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid="return-dialog">
        <DialogHeader>
          <DialogTitle>Riconsegna {rental.plate}</DialogTitle>
          <DialogDescription>{rental.provider} · ritirato il {fmtDate(rental.pickup_date)} con {rental.km_start.toLocaleString("it-IT")} km</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5"><Label>Data riconsegna</Label><Input type="date" min={rental.pickup_date} value={f.return_date} onChange={set("return_date")} data-testid="return-date-input" /></div>
          <div className="space-y-1.5"><Label>Km finali</Label><Input type="number" min={rental.km_start} value={f.km_end} onChange={set("km_end")} data-testid="return-km-end-input" />
            {km !== null && <p className={`text-xs ${km < 0 ? "text-rose-600" : "text-slate-500"}`} data-testid="return-km-driven">{km < 0 ? "Inferiori ai km iniziali" : `${km.toLocaleString("it-IT")} km percorsi`}</p>}
          </div>
          <div className="space-y-1.5 sm:col-span-2"><Label>Danni alla riconsegna</Label><Textarea rows={3} value={f.return_notes} onChange={set("return_notes")} placeholder="Lascia vuoto se nessun danno" data-testid="return-notes-input" /></div>
          <div className="sm:col-span-2"><RentalPhotos label="Foto alla riconsegna" photos={photos} setPhotos={setPhotos} files={files} setFiles={setFiles} testId="rental-return" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={saving || f.km_end === ""} data-testid="return-save-button">{saving ? "Salvataggio..." : first ? "Registra riconsegna" : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
